import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsOnboarding({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g clipPath="url(#settings-onboarding_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.86 4.16V.79a.3.3 0 00-.3-.29h-1.35a.3.3 0 00-.3.3v1.76L7.75.76a1.17 1.17 0 00-1.48 0L.1 5.84a.3.3 0 00-.04.41L.69 7a.3.3 0 00.4.04l5.72-4.71a.3.3 0 01.38 0l5.71 4.7a.3.3 0 00.41-.03l.62-.76a.3.3 0 00-.04-.4l-2.03-1.68zM2.5 7.22a.5.5 0 01.17-.37l4-3.55a.5.5 0 01.66 0L11.5 7h.01c0 .02 0 .03-.02.03A5 5 0 008.15 8.8c-.1.12-.24.2-.4.2H6a.5.5 0 00-.5.5V12a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5V7.22zM16 12a4 4 0 11-8 0 4 4 0 018 0zm-3.66-2.32l.04.03.04.04 1.7 1.63a.6.6 0 01-.78.94l-.07-.06-.66-.64v2.27a.6.6 0 01-1.21.08v-2.35l-.67.64a.6.6 0 01-.9-.8l.05-.08 1.7-1.63.05-.04.04-.03.04-.03.04-.02.07-.02.09-.02a.61.61 0 01.35.05l.08.04z"
        />
      </g>
    </svg>
  );
}

SvgSettingsOnboarding.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsOnboarding.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsOnboarding svgRef={ref} {...props} />
));
export default ForwardRef;
